import $ from "jquery";

var $load = false;

(function ($) {
  var initializeTestinomialBlock = function ($block) {
    // console.log("init slick", $block);
    $(".module__text-slider--wrapper").slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 500,
      centered: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  };
  // Initialize each block on page load (front end).
  $(document).ready(function () {
    // console.log("Page loaded");
    initializeTestinomialBlock();
  });
  //   // Initialize dynamic block preview (editor).
  if (window.acf) {
    if ($load === false) {
      //   window.acf.addAction("render_block_preview", initializeTestinomialBlock);
      $load = true;
    }
  }
})(jQuery);
